import { isCashRewards } from "./isCashRewards";

export const getEarnMultiplier = (currency?: string) => {
  const multiplier = isCashRewards(currency) ? "%" : "X";
  const currencyText = currency || "miles";
  return { multiplier, currency: currencyText };
};
